// Copyright (c) 2022 by Move Closer.

import { RouteConfig } from 'vue-router'
import { RoutesFactory } from '@movecloser/front-core'

import { buildStaticRoutesDefinitions, StaticRouteDefinition } from '../../contexts'

export enum RouteNames {
  Map = 'poi.map',
  Single = 'poi.single',
}

export const poiModuleStaticRoutes: StaticRouteDefinition[] = buildStaticRoutesDefinitions(
  'poi',
  Object.values(RouteNames)
)

export const routesFactory: RoutesFactory = (): RouteConfig[] => {
  return [
    {
      path: '/map',
      name: RouteNames.Map,
      meta: { auth: false, metaTitle: 'POI Map', static: true },
      component: () => import(/* webpackChunkName: "poi/map" */ './views/PoiMap.vue')
    },
    {
      path: '/map/:slug?',
      name: RouteNames.Single,
      meta: { auth: false, metaTitle: 'POI Details', static: true },
      component: () => import(/* webpackChunkName: "poi/single" */ './views/PoiSingle.vue')
    }
  ]
}
